import axios from 'axios';

export function getApiErrorMessage(error: unknown, fallback = 'Request failed'): string {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.error?.message || error.message || fallback;
  }
  if (error instanceof Error) return error.message;
  return fallback;
}
